import { createColorKeys } from '~/utils/chakraUtils'

import { pendingMessageBubbleColors } from './PendingMessageBubble.colors'

export const messagingColors = {
  Messaging: {
    PendingMessageBubbleColors: pendingMessageBubbleColors,
  },
}

export const messagingColorKeys = createColorKeys(messagingColors)
